// TODO: Should have both a Whitelist and a Blacklist version of this function.
export function hasDifferentRoute(curRoute, prevRoute, ignoredProps) {
  if (!prevRoute) {
    return true;
  }

  if (curRoute.pathname !== prevRoute.pathname) {
    return true;
  }

  if (curRoute.slug !== prevRoute.slug) {
    return true;
  }

  const changedProps = queryCompare(curRoute.query, prevRoute.query);
  const changedRelevantProps = removeIgnoredValues(changedProps, ignoredProps);

  return changedRelevantProps.length > 0;
}

export function urlSplitter(href) {
  return {
    // href is always the first part...
    href: href.split('?')[0].split('#')[0],
    // Get query.  The double-split clears all unneeded values/being in the wrong order.
    query:
      href.indexOf('?') > -1 ? href.split('?')[1].split('#')[0] : undefined,
    // Get hash.  The double-split clears all unneeded values/being in the wrong order.
    hash: href.indexOf('#') > -1 ? href.split('#')[1].split('?')[0] : undefined,
  };
}

export function queryCompare(query1 = {}, query2 = {}) {
  let unequalValues = [];
  let key;
  for (key in query1) {
    if (
      typeof query1[key] !== 'undefined' &&
      (!query2[key] || query1[key].toString() !== query2[key].toString()) &&
      unequalValues.indexOf(key) === -1
    ) {
      unequalValues.push(key);
    }
  }
  for (key in query2) {
    if (
      typeof query2[key] !== 'undefined' &&
      (!query1[key] || query1[key].toString() !== query2[key].toString()) &&
      unequalValues.indexOf(key) === -1
    ) {
      unequalValues.push(key);
    }
  }

  return unequalValues;
}

export function removeIgnoredValues(differences, ignoredValues) {
  return differences.reduce((accum, ele) => {
    if (ignoredValues.indexOf(ele) === -1) {
      accum.push(ele);
    }
    return accum;
  }, []);
}
